module.exports = __webpack_public_path__ + "static/img/B_zhuce.dd51fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/B_zhuce.png
// module id = ZHrJ
// module chunks = 69